import { render, staticRenderFns } from "./nodes.vue?vue&type=template&id=47a724dc&scoped=true"
import script from "./nodes.vue?vue&type=script&lang=js"
export * from "./nodes.vue?vue&type=script&lang=js"
import style0 from "./nodes.vue?vue&type=style&index=0&id=47a724dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a724dc",
  null
  
)

export default component.exports